import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAppStore = create(
  persist(
    (set) => ({
      nightMode: true,
      recentLookups: [],
      toggleNightMode: () => set((s) => ({ nightMode: !s.nightMode })),
      setNightMode: (value) => set({ nightMode: value }),
      addRecentLookup: (entry) =>
        set((s) => ({
          recentLookups: [
            entry,
            ...s.recentLookups.filter((l) => l.number !== entry.number),
          ].slice(0, 20),
        })),
    }),
    {
      name: 'spamblocker-app',
      partialize: (state) => ({
        nightMode: state.nightMode,
        recentLookups: state.recentLookups,
      }),
    }
  )
);
